<template>
  <div
    class="screen-search-box-fa"
    :style="`display:${isDisplay ? 'block' : 'none'}`"
  >
    <div class="screen-search-box">
      <slot></slot>
      <div class="screen-search-box-btn">
        <el-button class="pop-close" @click="close">{{$t('shortNoun.Close')}}</el-button
        >
        <el-button class="pop-save" @click="submit">确认并查询</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isDisplay: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>